import React, { useRef } from "react";
import Header from "../../Componets/Header/Header";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Footer from "../../Componets/Footer/Footer";

import { useState } from "react";
import { useEffect } from "react";
import ImageSlider from "../Homepage/ImageSlider";
import { useComponentUtils } from "../../layout/utilscomponent";
import Loader from "../../Componets/loader";
import useFetchCommon from "../../Componets/usefetchcommon";
import { SkeletonLoadSlider } from "../skeletonLoad/skeletonthumbnail";
import CommonBannerSlider from "../../Componets/commonSlider";
import { useDispatch, useSelector } from "react-redux";
import { setIsRendered } from "../../Redux/Slice/dataRender";
import { setInnerPagesData } from "../../Redux/Slice/innerPageDataSlice";

const NewsData = () => {
  localStorage.removeItem("event_title");
  localStorage.removeItem("event_genres");
  localStorage.removeItem("event_identifyunic");
  localStorage.removeItem("event_seo_url_friendly");
  localStorage.removeItem("event_seo_url");
  localStorage.removeItem("relatedmovietitle");

  localStorage.removeItem("event_first");
  localStorage.removeItem("event_secund");
  localStorage.removeItem("event_three");
  localStorage.removeItem("event_four");
  localStorage.removeItem("event_five");
  localStorage.removeItem("SublistTitle");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(4);
  const [nPageSize, setNPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [newsPageData, setNewsPageData] = useState({});
  const [catalogListData, setCatalogListData] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [innerCatalogListData, setInnerCatalogListData] = useState([]);
  const [isMoreAdded, setIsMoreAdded] = useState(true);
  const [totalItemsCount, setTotalItemsCount] = useState(0);
  const [isrecordsfound, setIsrecordsfound] = useState(true);
const dispatch = useDispatch()
const effectRan = useRef(false)
  const { renderCategoryBlockWithLayoutType } = useComponentUtils(
    catalogListData,
    hasMore,
    setHasMore,
    setLoading,
    loading,
    setCatalogListData,
    innerCatalogListData,
    setInnerCatalogListData
  );

  // useEffect(() => {
  //   fetchData();

  // }, []);

  // useEffect(() => {

  //   (async () => {
  //     let data = await fetchData();
  //     let updateddata
  //     if (catalogListData.length) {
  //       updateddata = [...catalogListData, ...data?.catlogData]
  //     } else {
  //       updateddata = [...data?.catlogData]
  //     }
  //     if (!NewsPageData.catalog_list_items) {
  //       setNewsPageData(data?.homePageData)
  //     }
  //     setCatalogListData(updateddata)
  //   })();

  // }, [page]);


  const performFetch = async () => {
    if (loading) return; 
    setLoading(true);    

    try {
      let data = await fetchData();  

      if (!data || !data?.catlogData) {
        console.error('Data or catlogData is undefined.');
        setLoading(false); 
        return;
      }

      let updatedData = catalogListData?.length
        ? [...catalogListData, ...(data?.catlogData || [])]
        : [...(data?.catlogData || [])];

      if (!newsPageData.catalog_list_items) {
        setNewsPageData(data?.homePageData);
      }
      dispatch(setInnerPagesData({innerPagesData: data?.homePageData}))
      setCatalogListData(updatedData);
      const newPage = page + 1;
      setPage(newPage);
      if(data?.homePageData?.catalog_list_items.length === 0){
        setIsrecordsfound(false);
      }
     
      setTotalItemsCount(data?.homePageData?.total_items_count);

    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);  
    }
  };



  useEffect(() => {
    if(effectRan.current === false){
      performFetch();
      return () => {
        effectRan.current = true
      }
    }
  }, []);


  useEffect(() => {
    window.addEventListener('scroll', loadMoreData);
  }, [isMoreAdded]);

  const loadMoreData = () => {
    if (
      window.innerHeight + document.documentElement.scrollTop >= document.scrollingElement.scrollHeight - 100
    ) {
      if ((page + 1) * pageSize >= newsPageData.total_items_count) return
      let pageNumber = page + 1
      window.removeEventListener('scroll', loadMoreData);
      setPage(pageNumber)
      dispatch(setIsRendered({ isRendered: true}));
      // setTimeout(() => {
      //   setIsMoreAdded(!isMoreAdded)
      // }, 1000);
      setIsMoreAdded(!isMoreAdded);

    }
  };


  


  const fetchData = useFetchCommon(
    page,
    pageSize,
    nPageSize,
    setInnerCatalogListData,
    setNewsPageData,
    setCatalogListData,
    setLoading,
    toast,
    setPage,
    setHasMore
  );

  const handleScroll = () => {
    const nearBottom = window.innerHeight + window.scrollY > document.body.offsetHeight - 100; 
    if (nearBottom && !loading && isrecordsfound && totalItemsCount > 0) {
      performFetch();
    }
  };


  
  useEffect(() => {
    if((page) * pageSize > newsPageData?.total_items_count) return;
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [catalogListData, page, totalItemsCount, loading]);

  return (
    <>
      <div className="banner homepage">
        {/* <Header /> */}
        {!loading ? (
          catalogListData &&
          catalogListData?.length > 0 && (
            <CommonBannerSlider
              innerCatalogListData={innerCatalogListData}
              catalogListData={catalogListData}
              homePageData={newsPageData}
            />
          )
        ) : (
          <SkeletonLoadSlider />
        )}
        <div className="banner-layer"></div>
      </div>

<div className="main-block background-layer">
{catalogListData?.map((val, index) => {
  const layoutType =  val.web_layout_type ?? val.layout_type;

  let thumbnailSize = null;

  if (layoutType === 'etv-exclusive_banner' || layoutType === 'tv_shows_banner') {
    thumbnailSize = 'web_banner';
  } else if (['episode', 'latest_episode', 'videos'].includes(layoutType)) {
    thumbnailSize = 'medium_16_9';
  } else if (layoutType === 'tv_shows') {
    thumbnailSize = 'medium_3_4';
  }

  const isBannerType = ['top_banner', 'banner'].includes(layoutType);

  return (
    !isBannerType && (
      <React.Fragment key={index}>
        {renderCategoryBlockWithLayoutType(layoutType, val.display_title, val.layout_structure, thumbnailSize)}
      </React.Fragment>
    )
  );
})}



</div>


      {catalogListData && catalogListData?.length > 0 && <Footer />}
    </>
  );
};

export default NewsData;
